export default __webpack_public_path__ + "static/media/katherine_johnson_galileu.a9b0feaa.jpg";